import { Box } from "grommet";
import React from "react";
import StandardColors from "../../../../../../../util/StandardColors";
import CardTitle from "../CardTitle/CardTitle";
import "./CountCard.css";

type CountCardPropsType = {
  title: string;
  count: number;
  bgColor: string;
  mt?: number;
};

const CountCard = ({ title, count, bgColor, mt }: CountCardPropsType) => (
  <Box
    elevation="xsmall"
    background={bgColor}
    fill
    className="count-card-main"
    direction="column"
    align="center"
    style={{marginTop: mt}}
  >
    <div className="count-card-container">
      <p className="count-card-text">{count}</p>
      <CardTitle>{title}</CardTitle>
    </div>
  </Box>
);

export default CountCard;
